import { ErrorMessage, type FieldValuesFromFieldErrors } from '@hookform/error-message';
import type { PropsWithChildren } from 'react';
import type { FieldErrors, FieldName, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import cn from '@/utils/merge-class-names';
import { translateComplexKey } from '@/utils/translate';

interface Props<TFieldValues extends FieldValues> {
  name: FieldName<FieldValuesFromFieldErrors<FieldErrors<TFieldValues>>>;
  errors: FieldErrors<TFieldValues>;
  helperText?: string;
  className?: string;
}

export function FieldMessage<TF extends FieldValues = Record<string, never>>({
  name,
  errors,
  helperText = '',
  className,
  children,
}: PropsWithChildren<Props<TF>>) {
  const { t } = useTranslation();

  return (
    <div className='label empty:hidden'>
      {errors[name] ? (
        <ErrorMessage
          key={name}
          name={name}
          errors={errors}
          render={({ message }) => <span className='label-text-alt text-error'>{translateComplexKey(message, t)}</span>}
        />
      ) : (
        !!helperText && <span className={cn('label-text-alt text-secondary', className)}>{helperText}</span>
      )}

      {children}
    </div>
  );
}
